export default "__VITE_ASSET__D7Hn1UF7__"